var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.textLocal),callback:function ($$v) {_vm.textLocal=$$v},expression:"textLocal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }